import React, { useContext, useEffect } from 'react';
import { AuthContext } from '../components/Auth';
import { useNavigate } from 'react-router-dom';

const Login: React.FC = () => {
  const { login, isAuthenticated, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  
  // If already authenticated, redirect to home
  useEffect(() => {
    if (isAuthenticated && !loading) {
      navigate('/');
    }
  }, [isAuthenticated, loading, navigate]);
  
  // Handle login button click
  const handleLoginClick = (e: React.MouseEvent) => {
    e.preventDefault();
    login();
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            AI Leads Manager
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Secure access with Google Authentication
          </p>
        </div>
        <div className="mt-8 space-y-6">
          <div>
            <button
              onClick={handleLoginClick}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <span className="flex items-center">
                <svg className="h-5 w-5 mr-2" fill="white" viewBox="0 0 24 24">
                  <path d="M12.24 10.285V14.4h6.806c-.275 1.765-2.056 5.174-6.806 5.174-4.095 0-7.439-3.389-7.439-7.574s3.345-7.574 7.439-7.574c2.33 0 3.891.989 4.785 1.849l3.254-3.138C18.189 1.186 15.479 0 12.24 0c-6.635 0-12 5.365-12 12s5.365 12 12 12c6.926 0 11.52-4.869 11.52-11.726 0-.788-.085-1.39-.189-1.989H12.24z" />
                </svg>
                Sign in with Google
              </span>
            </button>
          </div>
          
          <div className="text-sm text-center mt-4">
            <p className="text-gray-500">
              This application is restricted to authorized users only.
              <br />
              Only slav.durej@gmail.com can access this application.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 